import { type MessagePayload } from 'firebase/messaging';

export type PushNotificationData = Record<string, string | undefined>;

export const normalizePushPayloadData = (payload: Pick<MessagePayload, 'data'>): PushNotificationData => {
    const rawData = payload.data ?? {};
    const nestedRaw = rawData.data;

    if (!nestedRaw) {
        return rawData;
    }

    try {
        const nested = JSON.parse(nestedRaw) as unknown;
        if (!nested || typeof nested !== 'object' || Array.isArray(nested)) {
            return rawData;
        }

        return {
            ...rawData,
            ...(nested as Record<string, string | undefined>),
        };
    } catch {
        return rawData;
    }
};
